import { PaymentGatewayType, SpreedlySupportedGateway } from '../types/gateway-type.model'

export interface PaymentGateway {
  pkey: string
  gateway: string
  service: PaymentGatewayServiceIdentities
  default: number
  handler: string
  credentials: any
  archived: number
  status: number
  name: string
  account: number
  created: number
  owner_id: string
  creator: string
  primary_email_confirmed: boolean
  has_oauth_integrations: 0 | 1
  isIntegrationReady: 0 | 1
  payments_receivable: boolean
  merchant_id?: string
}

export class DefaultPaymentGateway {
  gateway_id: string
  livemode: boolean
  service: PaymentGatewayServiceIdentities
}

export interface PaymentGatewayView extends PaymentGateway {
  type: PaymentGatewayType
  spreedly: SpreedlySupportedGateway
  gatewayName: string
  identity: string
  ownerName?: string
  creatorName?: string
}

export enum PaymentGatewayServiceIdentities {
  PayPalV2 = 'paypalv2',
  PayPal = 'paypal',
  Stripe = 'stripe',
  Worldpay = 'worldpay',
  Braintree = 'braintree',
  Paymill = 'paymill',
  PayPalCommercePlatform = 'paypal_commerce_platform',
  Paysafe = 'optimal_payments',
  AuthorizeNET = 'authorize_net',
  Peach = 'peach',
}

export const enabledPaymentGatewayTypes = [
  PaymentGatewayServiceIdentities.PayPal,
  PaymentGatewayServiceIdentities.Stripe,
  PaymentGatewayServiceIdentities.Worldpay,
  PaymentGatewayServiceIdentities.Braintree,
  PaymentGatewayServiceIdentities.Paymill,
  PaymentGatewayServiceIdentities.PayPalCommercePlatform,
  PaymentGatewayServiceIdentities.Paysafe,
  PaymentGatewayServiceIdentities.AuthorizeNET,
  PaymentGatewayServiceIdentities.Peach,
]
